import { render, staticRenderFns } from "./shopAddEdit.vue?vue&type=template&id=fb84dba6&scoped=true&"
import script from "./shopAddEdit.vue?vue&type=script&lang=js&"
export * from "./shopAddEdit.vue?vue&type=script&lang=js&"
import style0 from "./shopAddEdit.vue?vue&type=style&index=0&id=fb84dba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb84dba6",
  null
  
)

export default component.exports